import React from 'react';
import { T } from './tokens';

export default function AlertBanner({ type, message, onClose }) {
  if (!message) return null;
  const styles = {
    error: { bg: '#FEE2E2', color: '#991B1B' },
    success: { bg: T.greenSoft, color: T.green },
    warning: { bg: '#FEF3C7', color: '#92400E' },
  }[type] || { bg: '#F1F2F5', color: T.ink };

  return (
    <div style={{
      background: styles.bg, color: styles.color, padding: '10px 14px', borderRadius: 8,
      marginBottom: 16, fontSize: 13, display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    }}
    >
      <span>{message}</span>
      {onClose && (
        <button type="button" onClick={onClose} style={{ border: 'none', background: 'transparent', cursor: 'pointer', color: 'inherit' }}>×</button>
      )}
    </div>
  );
}
